import PropTypes from 'prop-types';
import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

import Spinner from 'components/Spinner';
import './WithLoading.scss';

export default function withLoading(Comp) {
    LoadingComponent.propTypes = {
        isLoading: PropTypes.bool.isRequired
    };

    LoadingComponent.displayName = `withLoading(${Comp.displayName || Comp.name})`;

    function LoadingComponent(props) {
        if (props.isLoading) {
            return (
                <main className='with-loading-wrapper'>
                    <div className='loading-vcenter loading-container text-center'>
                        <Spinner color='#35CE8D' />
                    </div>
                </main>
            );
        }

        return <Comp {...props} />;
    }

    return hoistNonReactStatic(LoadingComponent, Comp);
}
